import { useCurrentUser } from '../../hooks/useCurrentUser'
import { ApplicantHome, ParticipantHome, ProspectHome } from './ProspectHome'

/**
 * Home route. Branches on the user's status — the single seam where each status
 * renders its own section stack while shared home furniture stays consistent.
 */
export function HomeScreen() {
  const user = useCurrentUser()

  switch (user.status) {
    case 'prospect':
      return <ProspectHome user={user} />
    case 'applicant':
      return <ApplicantHome user={user} />
    case 'participant':
      return <ParticipantHome user={user} />
  }
}
